module.exports = Cesium.ScreenSpaceEventHandler;